import { getFormFromLocalStorage } from "pages/home/utils";
import { IStep3FormValues } from "./iStep3FormValues";
import { useFormik } from "formik";
import { validations } from "./validations";

export interface UseStep3FormProps {
  onSubmit: (values: IStep3FormValues) => void;
}

export function useStep3Form(props: UseStep3FormProps) {
  const formFromLocalStorage = getFormFromLocalStorage();
  const form = useFormik<IStep3FormValues>({
    initialValues: {
      products: formFromLocalStorage?.products || [],
      interestPlan: formFromLocalStorage?.interestPlan || []
    },
    validationSchema: validations,
    onSubmit: props.onSubmit,
  });

  return {
    ...form,
  };
}
